import { FileViewer } from "../../../shared/FileViewer";

/**
 * Label for the control that opens the sheet beside the job.
 * @param {boolean} [open]
 * @returns {string}
 */
export function previewFileButtonLabel(open) {
  return open ? "Hide preview" : "Preview file";
}

/**
 * Sheet grid for a file-created job.
 * Shown in the left half of the job body. The tab header sits above the info pane.
 *
 * @param {object} props
 * @param {object} props.job
 * @param {() => void} [props.onClose]
 */
const JobSheetPreview = ({ job, onClose }) => {
  const sheets = job?.metadata?.extractedData?.sheets;
  const fileName =
    job?.metadata?.import?.fileName || job?.metadata?.extractedData?.fileName;
  if (!Array.isArray(sheets) || sheets.length === 0) return null;

  return (
    <div className="h-full min-h-0 [&_.spreadsheet-viewer]:h-full [&_.spreadsheet-viewer]:rounded-none [&_.spreadsheet-viewer]:border-0">
      <FileViewer
        fileType="excel"
        sheetData={sheets}
        excelSheets={sheets}
        fileName={fileName}
        onClose={onClose}
        viewerStyle={{ height: "100%", width: "100%" }}
      />
    </div>
  );
};

export default JobSheetPreview;
